// extracted by mini-css-extract-plugin
export default {"layout":"PunchupTableLayout_layout__UrKcg"};